import { createFileRoute, Outlet } from '@tanstack/react-router';

import { requirePermission } from '@/app/guards';

/** Layout of the store's content screens: a "Content" crumb and the read guard for all of them. */
export const Route = createFileRoute('/_authed/_active/s/$storeId/content')({
  staticData: { crumb: 'common:nav.content' },
  beforeLoad: ({ context }) => {
    requirePermission(context.me, 'content.read');
  },
  component: Outlet,
});
